import { timeoutPromise } from './promise';

/**
 * Returns the parsed JSON response of a GET request to the given URL
 * @param url
 * @param init
 * @param timeout
 */
export async function fetchJson<T>(url: string, init?: RequestInit, timeout?: number): Promise<T> {
  return (timeout ? timeoutPromise(fetch(url, init), timeout, 'Request timed out') : fetch(url, init))
    .then(
      async (res: Response) => {
        if (res.status >= 400) {
          return Promise.reject(`Unable to fetch JSON data (HTTP error): ${url}, ${res.status}, ${res.statusText}`)
        } else {
          let data;
          try {
            data = await res.json();
          } catch (err) {
            return Promise.reject(`Unable to parse response data: ${err}`);
          }

          return data || null;
        }
      },
      (err) => {
        return Promise.reject(`Unable to fetch JSON data (rejected): ${err}`);
      }
    );
}
